module.exports = __webpack_public_path__ + "img/raspberry_pi.png";